import { environmentConfig } from "@src/appV2/environment";
import { type History } from "history";

import {
  PLACEMENT_CANDIDATES_LINK_SOURCES_PAGES,
  type PlacementCandidatesLinkSourceEvent,
  type PlacementCandidatesLinkSourcePagesKeys,
} from "./constant";

function findLinkSourcePage(linkSource: PlacementCandidatesLinkSourceEvent) {
  const pageNames = Object.keys(
    PLACEMENT_CANDIDATES_LINK_SOURCES_PAGES
  ) as PlacementCandidatesLinkSourcePagesKeys[];
  return pageNames.find((page) =>
    PLACEMENT_CANDIDATES_LINK_SOURCES_PAGES[page].includes(linkSource)
  );
}

export function getCandidateUrlPath(
  accessId: string,
  currentWorkplaceId: string | undefined,
  linkSource: PlacementCandidatesLinkSourceEvent,
  metadata?: Record<string, string | boolean>
) {
  const metadataSource = {
    linkSourceEvent: findLinkSourcePage(linkSource),
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line unicorn/prefer-global-this
    linkSourceBrowserPath: window.location.pathname,
    ...metadata,
  };

  // eslint-disable-next-line no-restricted-globals
  const metadataSourceInBase64 = btoa(JSON.stringify(metadataSource));
  const candidateUrl = `/workplace/hire-professionals/${accessId}?noScroll=true&linkSource=${linkSource}&metadataSource=${metadataSourceInBase64}`;
  if (currentWorkplaceId) {
    return `${candidateUrl}&overrideUserId=${currentWorkplaceId}`;
  }

  return candidateUrl;
}

export function getCandidateUrl(
  accessId: string,
  currentWorkplaceId: string | undefined,
  linkSource: PlacementCandidatesLinkSourceEvent,
  metadata?: Record<string, string>
) {
  const urlPath = getCandidateUrlPath(accessId, currentWorkplaceId, linkSource, metadata);
  return `${environmentConfig.REACT_APP_ADMIN_APP_CLIENT_URL}${urlPath}`;
}

export function consumeUrlSearchParameter(
  parameterName: string,
  urlSearchParams: URLSearchParams,
  history: History
) {
  const parameter = urlSearchParams.get(parameterName);
  urlSearchParams.delete(parameterName);

  history.replace({
    pathname: location.pathname,
    search: urlSearchParams.toString(),
  });

  return parameter ?? undefined;
}

export function consumeMetadataSource(urlSearchParams: URLSearchParams, history: History) {
  const metadataSource = consumeUrlSearchParameter("metadataSource", urlSearchParams, history);
  if (!metadataSource) {
    return undefined;
  }

  // eslint-disable-next-line no-restricted-globals
  return JSON.parse(atob(metadataSource)) as Record<string, string>;
}
